<template>
<div class="mt-2">
    <div id="chart">
        <apexchart ref="apexchart1" type="scatter" :options="chartOptions" :series="series" height="250" />
    </div>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    name: 'c-asistencial-GraficoMedicamento',
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: "scatter",
                    zoom: {
                        enabled: true,
                        type: "y"
                    },
                },
                xaxis: {
                    type: "datetime",
                    title: {
                        text: "Hora Administrada"
                    },
                    labels: {
                        datetimeFormatter: {
                            minute: 'HH:mm'
                        }
                    },
                    tickAmount: 96, // 24 hours * 4 (15-minute intervals)
                },
                yaxis: {
                    title: {
                        text: "Cantidad Administrada"
                    },
                },
                markers: {
                    size: 4,
                },
                legend: {
                    position: "top",
                },
                tooltip: {
                    x: {
                        format: "HH:mm"
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => val,
                },
                grid: {
                    show: true,
                    borderColor: "#e0e0e0", // Color de las líneas de la cuadrícula
                    yaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                },
            },
        };
    },
    props: {
        recipe: {
            type: Array,
            default: [],
        }
    },
    watch: {
        recipe: {
            handler(newVal) {
                this.series = newVal.map(item => {
                    return {
                        ...item,
                        data: item.data.map(dataPoint => {
                            if (!dataPoint[0]) {
                                console.error('Invalid time format:', dataPoint[0]);
                                return [NaN, dataPoint[1]];
                            }
                            const today = new Date().toISOString().split('T')[0]; // Obtiene YYYY-MM-DD en formato ISO
                            const dateTimeString = `${today}T${dataPoint[0]}`; // Une la fecha con la hora
                            const dateTime = new Date(dateTimeString);
                            if (isNaN(dateTime.getTime())) {
                                console.error('Invalid date:', dateTimeString);
                                return [NaN, dataPoint[1]];
                            }
                            const peruTime = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)); // Adjust for timezone offset
                            return [peruTime.getTime(), dataPoint[1]];
                        })
                    };
                });
                this.mtdChangeGraphic();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        // Define your computed properties here
    },
    methods: {
        mtdChangeGraphic() {
            //Refrescar el grafico
            this.$nextTick(() => {
                if (this.$refs.apexchart1) {
                    this.$refs.apexchart1.updateSeries(this.series);
                    //this.$refs.apexchart1.updateOptions(this.chartOptions);
                }
            });
        },
    }
};
</script>
